<template>
    <div v-if="installation">
        <vrm-header :installation="installation">
            <template v-slot:header-title>
                {{ installation.name }}
            </template>
        </vrm-header>
        <vrm-title>
            <template v-slot:page-title>
                <h1 class="vrm-page-title">
                    {{
                        $t('custom_widgets.edit_custom_widget', {
                            i18nFallback: 'Edit custom widget',
                        })
                    }}
                </h1>
            </template>
        </vrm-title>

        <div class="container">
            <edit-custom-widget-form :id-site="idSite" :id-custom-widget="idCustomWidget" />
        </div>
    </div>
</template>
<script>
import { Vue, Component, Watch } from 'vue-property-decorator';
import VrmHeader from '@/vue/components/layout/VrmHeader';
import VrmTitle from '@/vue/components/layout/VrmTitle';
import { AngularRoute, ngInject } from '@/vue/decorators/angular-interop';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';
import EditCustomWidgetForm from '@/vue/components/shared/custom-widgets/EditCustomWidgetForm';

@Component({
    components: { EditCustomWidgetForm, VrmHeader, VrmTitle },
})
@AngularRoute('base.installation.edit-custom-widget', '/custom-widget/{idCustomWidget:int}', {
    slot: 'body',
})
@AngularLocaleBundle('core')
@AngularLocaleBundle('custom_widgets')
export default class CustomWidget extends Vue {
    @ngInject()
    InstallationsService;

    installation = null;

    get idSite() {
        return this.$route.params.id;
    }

    get idCustomWidget() {
        return this.$route.params.idCustomWidget;
    }

    @Watch('idSite', { immediate: true })
    async loadSiteData() {
        if (!this.idSite) return;
        const idBefore = this.idSite;
        const installation = await this.InstallationsService.getInstallation(this.idSite);
        if (idBefore !== this.idSite) return;
        this.installation = installation;
    }
}
</script>
